import { render, staticRenderFns } from "./areasimple.vue?vue&type=template&id=78abc7f8&scoped=true"
import script from "./areasimple.vue?vue&type=script&lang=js"
export * from "./areasimple.vue?vue&type=script&lang=js"
import style0 from "./areasimple.vue?vue&type=style&index=0&id=78abc7f8&prod&lang=scss&scoped=true"
import style1 from "./areasimple.vue?vue&type=style&index=1&id=78abc7f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78abc7f8",
  null
  
)

export default component.exports